<template>
  <div class="home-content">
    <!-- 微信认证组件 -->
    <wxAuth v-if="share" :share="share"></wxAuth>
    <div ref="homeHeader" class="home-header">
      <!-- title -->
      <headers :params="hraderP"></headers>
    </div>
    <div v-if="source !== 'app'" style="height:46px"></div>
    <!-- 搜索框 -->
    <search :param="searchParam"></search>
    <!-- 轮播图 -->
    <index-banner :indexTopBanner="CMSData.indexTopBanner || []" style="margin-top:12px"></index-banner>
    <!-- 顶部九宫格 -->
    <top-navigation :indexTopNavigationr="CMSData.indexTopNavigationr || []" style="margin-top:16px"></top-navigation>
    <!-- 秒杀方案 -->
    <limit-seckill v-if="isShow1"></limit-seckill>
    <!-- 每周推荐 -->
    <limit-seckill2></limit-seckill2>
    <!-- 热门方案 -->
    <index-hot-list style="margin-top:16px"></index-hot-list>
    <!-- 资讯页面 -->
    <news :posObj="posObj" ref="indexNews" style="margin-top:16px"></news>
    <!-- 底部企业信息说明 -->
    <msolutionFooter></msolutionFooter>
    <!-- 与底部浮动按钮高度一致 -->
    <!-- <div class="bottom-style"></div> -->
    <!-- 底部banner需求提交入口，滚动吸底 -->
    <!-- <van-row class="demand-content">
      <van-col :span="24"><router-link to="/demand/add.html"><button>提交需求 专人跟进</button></router-link></van-col>
    </van-row> -->
    <!-- <toSolBuy></toSolBuy> -->
    <toTop></toTop>
  </div>
</template>

<script>
import { getCookie } from '@/utils/cookies'
import { verifyLoginStatus } from '@/utils/common'
import { getCMSData } from '@/api/common'
import headers from '@/components/headers'
import news from './indexTemplate/news'
import topNavigation from './indexTemplate/topNavigation'
import indexHotList from './indexTemplate/indexHotList'
import indexBanner from '@/components/indexBanner'
import search from '@/components/search'
import hotList from '@/components/list'
import limitSeckill from '@/components/limitSeckill'
import limitSeckill2 from '@/components/limitSeckill2'
import hotLists from '@/components/hotLists'
import solutionsList from '@/components/solutionsList'
import wxAuth from '@/components/wxAuth'
import msolutionFooter from '@/components/footer'
import toTop from '@/components/toTop'
import toSolBuy from '@/components/toSolBuy'
import Cookies from 'js-cookie'
import { mapState } from 'vuex'
export default {
  name: 'home',
  components: { headers, search, wxAuth, hotList, msolutionFooter, hotLists, solutionsList, toTop, toSolBuy, news, indexBanner, topNavigation, indexHotList, limitSeckill,limitSeckill2 },
  computed: {
    ...mapState({
      yxsjsNews: state => state.home.yxsjsNews, // 优秀设计师
      hkjNews: state => state.home.hkjNews, // 黑科技
      hyghNews: state => state.home.hyghNews, // 行业干货
      advertising1: state => state.home.advertising1, // 行业干货
      advertising2: state => state.home.advertising2, // 行业干货
      hotKeyWord: state => state.solution.keyWords
    })
  },
  watch: {
    yxsjsNews (newV, old) {
      this.$data.params3.list = newV
    },
    hkjNews (newV, old) {
      this.$data.params4.list = newV
    },
    hyghNews (newV, old) {
      this.$data.params5.list = newV
    },
    hotKeyWord (newV, old) {
      if (newV && newV.length > 0) {
        this.$data.searchParam.placeholder = newV
      }
    }
  },
  data () {
    return {
      source: getCookie('homedo_port'),
      share: '',
      hraderP: {
        title: '河姆渡方案馆',
        lefticon: true
      },
      searchParam: {
        type: 'search01',
        url: '/hadoop/list.html',
        placeholder: ''
      },
      /* 参数说明
         list 数据列表
         type sol方案 info资讯
         isHotSearch  是否是热搜
         label  资讯是否需要标签
       */
      params3: {
        list: [],
        type: 'info'
      },
      params4: {
        list: [],
        type: 'info'
      },
      params5: {
        list: [],
        type: 'info'
      },
      scroll: null,
      isApp: false,
      ishotList: true,
      isNativeApp: true,
      posObj: '',
      CMSData: {},
      openForm: '',
      isShow1:false
    }
  },
  created () {
    verifyLoginStatus()
    if (Cookies.get('homedo_port') && Cookies.get('homedo_port').toUpperCase() === 'APP') {
      this.isApp = true
    }
    this.getData()
    this.$store.dispatch('SOLUTIONS_GET_KEYWORD')
    this.isNativeApp = !!(($HMD$.rNavigator && ($HMD$.rNavigator.toLowerCase() === 'ios' || $HMD$.rNavigator.toLowerCase() === 'android')))
    // eslint-disable-next-line no-mixed-operators
    this.openForm = this.$route.query && this.$route.query.openForm || ''
    this.getCMSData()
  },
  mounted () {
    // 测试bug
    if(localStorage.getItem('isShow1-20241212')){
      this.isShow1=true;
    }
  },
  methods: {
    getCMSData () {
      getCMSData().then((res) => {
        if (res.data && res.data.respCode === '0000') {
          this.CMSData = res.data.data || {}
          this.share = this.CMSData.indexWechatShare ? {...this.CMSData.indexWechatShare, url: window.location.href.split('#')[0]} : {
            title: '解决方案馆',
            desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
            imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
            url: window.location.href.split('#')[0]
          }
          setTimeout(() => {
            this.posObj = {
              headerHeight: this.$refs.homeHeader.clientHeight,
              slefTop: this.$refs.indexNews.$el.offsetTop,
              scrollHeight: this.$refs.indexNews.$el.offsetTop - this.$refs.homeHeader.clientHeight
            }
            this.openForm === 'pc' && this.scrollNew()
          }, 900)
        }
      })
    },
    scrollNew () {
      setTimeout(() => {
        this.$nextTick(() => {
          window.scrollTo(0, this.posObj.scrollHeight)
        })
      }, 100)
    },
    toggle (val) {
      this.ishotList = !val
    },
    getData () {
      // 查询广告信息
      if (!this.advertising1 || this.advertising1.length === 0) {
        this.$store.dispatch('HOME_GET_ADVERTISING_1')
      }
      // 查询广告信息
      if (!this.advertising1 || this.advertising1.length === 0) {
        this.$store.dispatch('HOME_GET_ADVERTISING_2')
      }
    }
  }
}
</script>

<style lang="scss">
  .tab .van-col {
    text-align: center;
  }
  .ad-position {
    width: 100%;
    background-color: white;
    margin-top: 10px;
    img{
      width: 100%;
      height: 105px;
      vertical-align: bottom;
    }
  }
  .home-content{
    background-color: #efeff4;
  }
  .home-header{
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 11;
  }
  .demand-content{
    width: 100%;
    position: fixed;
    bottom: 0px;
    button{
      width: 100%;
      border: none;
      height: 50px;
      background-color: #1DBFDA;
      color: white;
      font-size: 18px;
    }
  }
  .margin-top-144{
    margin-top: 144px;
  }
  .margin-top-100{
    margin-top: 100px;
  }
  .margin-top-80{
    margin-top: 89px;
  }
  .bottom-style{
    height: 50px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/view/home.vue